module.exports = __webpack_public_path__ + "static/img/5.d865e27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/5.png
// module id = qScs
// module chunks = 0